"use client";

import { c as _c } from "react/compiler-runtime";
import { useGeoSearch } from "@repo/design-system/hooks/use-geosearch";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import type { MapCenter } from "@repo/design-system/lib/map/helpers";
import { getCenterAndZoomForGeoLocation, getCenterAndZoomForLocale } from "@repo/design-system/lib/map/helpers";
import type { BranchMapPin } from "@repo/design-system/types/leaflet";
import dynamic from "next/dynamic";
import { useMemo } from "react";
import { LazyMap } from "./lazy-map";
const EON_LOCALE_OVERRIDES: Partial<Record<string, MapCenter>> = {
  en: {
    center: [52, 13],
    zoom: 4
  }
};

// ssr: false because leaflet cannot be imported on the server
const SearchRegion = dynamic(() => import("./search-region").then(mod => mod.SearchRegion), {
  ssr: false
});
interface JobboardMapProps {
  branches?: readonly BranchMapPin[];
  customCenter?: [number, number];
  customZoom?: number;
}
export default function JobBoardMap(t0) {
  const $ = _c(10);
  const {
    customZoom,
    customCenter,
    branches
  } = t0;
  const {
    geoLocation,
    radius,
    bboxSize
  } = useGeoSearch();
  const locale = useLocale();
  let t1;
  if ($[0] !== bboxSize || $[1] !== geoLocation || $[2] !== locale || $[3] !== radius) {
    t1 = geoLocation ? getCenterAndZoomForGeoLocation({
      geoLocation,
      radius,
      bboxSize
    }) : EON_LOCALE_OVERRIDES[locale ?? ""] ?? getCenterAndZoomForLocale(locale);
    $[0] = bboxSize;
    $[1] = geoLocation;
    $[2] = locale;
    $[3] = radius;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    center,
    zoom
  } = t1;
  const t2 = geoLocation ? center : customCenter || center;
  const t3 = geoLocation ? zoom : customZoom || zoom;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SearchRegion />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== branches || $[7] !== t2 || $[8] !== t3) {
    t5 = <LazyMap branches={branches} center={t2} zoom={t3}>{t4}</LazyMap>;
    $[6] = branches;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}